import * as React from 'react';

type Props = {
  width?: number;
  height?: number;
};

const GoogleLogoSVG = ({ width = 32, height = 32 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="presentation"
    >
      <circle cx="16" cy="16" r="16" fill="white" />
      <path
        d="M29.9999 16.3375C29.9999 15.35 29.9135 14.4125 29.7653 13.5H15.8147V19.1375H23.8024C23.4443 20.9875 22.3949 22.55 20.8394 23.6125V27.3625H25.6048C28.3949 24.75 29.9999 20.9 29.9999 16.3375Z"
        fill="#4285F4"
      />
      <path
        d="M15.8148 30.9998C19.8148 30.9998 23.1604 29.6498 25.6049 27.3623L20.8394 23.6123C19.5061 24.5123 17.8148 25.0623 15.8148 25.0623C11.9506 25.0623 8.67895 22.4248 7.50611 18.8623H2.59253V22.7248C5.02463 27.6248 10.0246 30.9998 15.8148 30.9998Z"
        fill="#34A853"
      />
      <path
        d="M7.50617 18.8629C7.19753 17.9629 7.03704 17.0004 7.03704 16.0004C7.03704 15.0004 7.20988 14.0379 7.50617 13.1379V9.27539H2.59259C1.58025 11.3004 1 13.5754 1 16.0004C1 18.4254 1.58025 20.7004 2.59259 22.7254L7.50617 18.8629Z"
        fill="#FBBC05"
      />
      <path
        d="M15.8148 6.93749C17.9999 6.93749 19.9506 7.69999 21.4938 9.18749L25.716 4.91249C23.1604 2.4875 19.8148 1 15.8148 1C10.0246 1 5.02463 4.375 2.59253 9.27499L7.50611 13.1375C8.67895 9.57499 11.9506 6.93749 15.8148 6.93749Z"
        fill="#EA4335"
      />
    </svg>
  );
};

export default GoogleLogoSVG;
